import { CCEF_PLATFORM_LINK } from '@oneethos/shared'
import { FaArrowUpRightFromSquare, FaHouseChimney } from 'react-icons/fa6'
import { IoInformationCircleOutline } from 'react-icons/io5'

type CcefAlertProps = {
  onDismiss: () => void
  onPlatformLinkClick: () => void
}

export const CcefAlert = ({ onDismiss, onPlatformLinkClick }: CcefAlertProps) => {
  return (
    <div className="my-3">
      <div
        className="border border-warning rounded p-4 bg-warning-subtle text-dark bg-opacity-25 d-flex mb-3"
      >
        <IoInformationCircleOutline size="30" className="me-2" />
        <div>
          <p>
            Climate First Bank has a partnership with the Collective Clean Energy Fund (CCEF) to offer
            loans of up to $75,000 to eligible homeowners in the state of <b>Colorado</b>.
          </p>
          <p>
            Our records indicate that your company is an approved contractor on the CCEF platform.
          </p>
          <p className="mb-3">
            If the project you’re referring does not include
            a roof or Tesla Solar Roof, please initiate this project on the CCEF platform:<br />
          </p>
          <a
            className="text-decoration-underline"
            href={CCEF_PLATFORM_LINK}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onPlatformLinkClick}
          >
            {CCEF_PLATFORM_LINK}
            <FaArrowUpRightFromSquare className="ms-2" color="text-primary" />
          </a>
        </div>
      </div>
      <button type="button" className="btn btn-primary" onClick={onDismiss}>
        <FaHouseChimney className="me-2" />
        My project contains a roof or Tesla Solar Roof
      </button>
    </div>
  )
}

export default CcefAlert
